import { render } from "./AddCourseLessonDialog.vue?vue&type=template&id=4edb9651&ts=true"
import script from "./AddCourseLessonDialog.vue?vue&type=script&lang=ts"
export * from "./AddCourseLessonDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__